import { FC, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'

import Logs, { LogsProps } from '../../components/Logs/Logs'
import { getDeletedLogs } from '../../redux/logs/logsActions'
import { setPaginationNumber } from '../../redux/pagination/paginationActions'

type LogsConnectorProps = LogsProps;

const LogsConnector: FC<LogsConnectorProps> = ({
    isLoading,
    logs,
    pagination,
}) => {
    const dispatch = useDispatch()

    const onPagination = (page: number) => {
        dispatch(setPaginationNumber(page))
        dispatch(getDeletedLogs())
    }

    useEffect(() => {
        dispatch(getDeletedLogs())
    }, [])

    return (
        <Logs
            pagination={pagination}
            isLoading={isLoading}
            logs={logs}
            onPagination={onPagination}
        />
    )
}

function mapStateToProps(state: any) {
    return {
        loading: state.logsReducer.loading,
        logs: state.logsReducer.deletedLogs,
        pagination: state.paginationReducer,
    }
}

export default connect(mapStateToProps)(LogsConnector)
